import { isValidYaml } from '@ion/mrdash';
import { ERROR_MESSAGES } from 'app/components/YamlCodeEditor/determineErrorMessage';

export default function validateYaml() {
  return value => (isValidYaml(value) ? null : ERROR_MESSAGES.INVALID_YAML);
}
